import React from 'react';
import { useUser, RedirectToSignIn } from "@clerk/clerk-react";
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';

const ProposalsPage: React.FC = () => {
  const { user, isSignedIn, isLoaded } = useUser();
  const adminEmail = "anant@nextgenerationmedicine.co";

  if (!isLoaded) {
    // Wait for Clerk to load user data
    return <div className="min-h-screen flex items-center justify-center"><p>Loading...</p></div>;
  }

  if (!isSignedIn) {
    // This should ideally be caught by route-level protection first
    // but acts as a fallback.
    return <RedirectToSignIn />;
  }

  if (user?.primaryEmailAddress?.emailAddress !== adminEmail) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-8 flex flex-col items-center justify-center">
          <h1 className="text-3xl font-bold mb-4">Access Denied</h1>
          <p>You do not have permission to view this page.</p>
        </main>
        <Footer />
      </div>
    );
  }

  // Admin view
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Proposals Dashboard</h1>
        <p className="mb-4">Welcome, Admin! Here are the client proposals:</p>
        
        <div className="bg-white p-6 rounded-lg shadow mb-8">
          <h2 className="text-xl font-semibold mb-3">Existing Proposals</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li><a href="/proposals/cactus052025" className="text-blue-600 hover:underline">Cactus Proposal (May 2025)</a></li>
            <li><a href="/proposals/plv052025" className="text-blue-600 hover:underline">PLV Proposal (May 2025)</a></li>
            <li><a href="/proposals/highmountmadison052025" className="text-blue-600 hover:underline">High Mount Madison / 4Ever Young Proposal (May 2025)</a></li>
            <li><a href="/proposals/nexthealth052025" className="text-blue-600 hover:underline">Next Health Proposal (May 2025)</a></li>
            <li><a href="/proposals/levey052025" className="text-blue-600 hover:underline">Levey Advisory Proposal (May 2025)</a></li>
            {/* Add more proposals here as they are created */}
          </ul>
        </div>

        {/* Placeholder for proposals list/dashboard content */}
        <div className="bg-gray-100 p-6 rounded-lg shadow">
          <p className="text-gray-700">Proposal data will be displayed here.</p>
          {/* Example structure you might use later:
          <ul>
            <li>Proposal 1 for Client A - View Details</li>
            <li>Proposal 2 for Client B - View Details</li>
          </ul>
          */}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProposalsPage;
